const ACTIVITY_RECORDED_EVENT = 'inactivity-rules:activity-recorded';

/** Tells this tab's inactivity rules that activity was just recorded, so a return from Away/Gray happens right away. */
export function notifyActivityRecorded(): void {
    window.dispatchEvent(new Event(ACTIVITY_RECORDED_EVENT));
}

export function onActivityRecorded(listener: () => void): () => void {
    window.addEventListener(ACTIVITY_RECORDED_EVENT, listener);
    return () => window.removeEventListener(ACTIVITY_RECORDED_EVENT, listener);
}

/**
 * Runs an async task without overlap. A request made while a run is in progress is remembered and
 * triggers exactly one follow-up run, so no request is lost and runs never pile up.
 */
export function createSerialRunner(task: () => Promise<void>, onError: (err: Error) => void = () => undefined): () => void {
    let isRunning = false;
    let isRerunRequested = false;

    const run = (): void => {
        if (isRunning) {
            isRerunRequested = true;
            return;
        }
        isRunning = true;
        task()
            .catch((err) => onError(err))
            .finally(() => {
                isRunning = false;
                if (isRerunRequested) {
                    isRerunRequested = false;
                    run();
                }
            });
    };

    return run;
}
